import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useBlockUnsavedChanges } from './useBlockUnsavedChanges';

export function useBlockNavigationWhenDirty(
  isDirty: boolean
) {
  const { t } = useTranslation();
  const promptMessage = t('un_saved_changes');
  const popstateActive = useRef(false);

  
  useBlockUnsavedChanges(isDirty, popstateActive, promptMessage, undefined, undefined);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    if (isDirty) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);

  // Handle browser back/forward navigation
  /* useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (!isDirty || popstateActive.current) return;
      popstateActive.current = true;
      const confirmed = window.confirm(promptMessage);
      if (!confirmed) {
        // User canceled: push back the trap state
        window.history.pushState('trap', '', window.location.pathname);
      } else {
        // User confirmed: allow navigation
        window.removeEventListener('popstate', handlePopState);
        window.history.back();
      }
      popstateActive.current = false;
    };
    if (isDirty) {
      // Only push dummy state if not already present
      if (window.history.state !== 'trap') {
        window.history.pushState('trap', '', window.location.pathname);
      }
      window.addEventListener('popstate', handlePopState);
    }
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isDirty, promptMessage]); */
}